import fetch from "isomorphic-fetch";
import { getItem } from "../utils/storage";

import {
  X_API_KEY,
  EXPIRE,
  TOKEN_TYPE,
  ID_TOKEN,
  INTEGRATED_EXPIRE,
  INTEGRATED_ID_TOKEN,
} from "../utils/constants";

export async function mfaStatus(agent_id) {
  const idToken = localStorage.getItem("idToken");//getItem(ID_TOKEN);
  const tokenType = localStorage.getItem("tokenType");//getItem(TOKEN_TYPE);

  return await fetch('https://apiv2.invoxcontact.com/bridge/en/invoxapi/Mfa', {
    headers: {
      Authorization: tokenType + " " + idToken,
      "x-api-key": X_API_KEY,
      "Content-Type": "application/json",
    },
    method: "POST",
    body: JSON.stringify({
      "action": "fetchMigrationStatus",
      "params": {
        "agent_id": agent_id
      }
    }),
  })
}

export async function mfaNotify(agent_id, email) {
  const idToken = localStorage.getItem("idToken");
  const tokenType =localStorage.getItem("tokenType");

  return await fetch('https://apiv2.invoxcontact.com/bridge/en/invoxapi/Mfa', {
    headers: {
      Authorization: tokenType + " " + idToken,
      "x-api-key": X_API_KEY,
      "Content-Type": "application/json",
    },
    method: "POST",
    body: JSON.stringify({
      "action": "reportMigrationIssue",
      "params": {
        "agent_id": agent_id,
        "wanted_email": email
      }
    }),
  })
}

export async function mfaMigrate(agent_id) {
  const idToken = localStorage.getItem("idToken");
  const tokenType =localStorage.getItem("tokenType");

  return await fetch('https://apiv2.invoxcontact.com/bridge/en/invoxapi/Mfa', {
    headers: {
      Authorization: tokenType + " " + idToken,
      "x-api-key": X_API_KEY,
      "Content-Type": "application/json",
    },
    method: "POST",
    body: JSON.stringify({
      "action": "requestMigration",
      "params": {
        "agent_id": agent_id
      }
    }),
  })
}

// dar de alta email
export async function mfaEmail(agent_id) {
  const idToken = localStorage.getItem("idToken");
  const tokenType =localStorage.getItem("tokenType");

  return await fetch('https://apiv2.invoxcontact.com/bridge/en/invoxapi/Mfa', {
    headers: {
      Authorization: tokenType + " " + idToken,
      "x-api-key": X_API_KEY,
      "Content-Type": "application/json",
    },
    method: "POST",
    body: JSON.stringify({
      "action": "dispatchMigrationLink",
      "params": {
        "agent_id": agent_id
      }
    }),
  })
}

export async function emailChange(agent_id, email) {
  const idToken = localStorage.getItem("idToken");
  const tokenType =localStorage.getItem("tokenType");

  return await fetch('https://apiv2.invoxcontact.com/bridge/en/invoxapi/Mfa', {
    headers: {
      Authorization: tokenType + " " + idToken,
      "x-api-key": X_API_KEY,
      "Content-Type": "application/json",
    },
    method: "POST",
    body: JSON.stringify({
      "action": "updateAgentEmail",
      "params": {
        "agent_id": agent_id,
        "email": email
      }
    }),
  })
}

export async function emailVerify(agent_id) {
  const idToken = localStorage.getItem("idToken");
  const tokenType =localStorage.getItem("tokenType");

  return await fetch('https://apiv2.invoxcontact.com/bridge/en/invoxapi/Mfa', {
    headers: {
      Authorization: tokenType + " " + idToken,
      "x-api-key": X_API_KEY,
      "Content-Type": "application/json",
    },
    method: "POST",
    body: JSON.stringify({
      "action": "dispatchVerifyLink",
      "params": {
        "agent_id": agent_id
      }
    }),
  })
}


// WEBPACK FOOTER //
// ./src/services/MfaServices.js